define('plugin/gallery/view/GalleryModuleItemView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Gallery item view
     *
     * @class GalleryModuleItemView
     */
    return LayoutView.extend({

        template: '#gallery_module_item_view'

    });

});
